export default {"src":"/login-app/[GIT_HASH]/_next/static/media/rss.97f01ce2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};